import type { ReadyDependencies, ReadyDependency, ReadyDependent } from '@legacy/Scripts/required/Cognito-core.d.ts';

let readyDependencies: ReadyDependencies = null;

/**
 * Sets the ready dependencies dictionary
 * @param value The ready dependencies dictionary to use
 */
export function setReadyDependencies(value: ReadyDependencies) {
	readyDependencies = value;
}

/**
 * Ready - handles tracking of one time dependencies to synchronize code execution
 */
export function ready(name: string);
export function ready(name: string, action: () => void);
export function ready(name: string, dependency: string);
export function ready(name: string, dependency: string, action: () => void);
export function ready(name: string, dependencies: string[]);
export function ready(name: string, dependencies: string[], action: () => void);
export function ready(name: string, arg2?: string | string[] | (() => void), arg3?: () => void): void {
	const dependencies = arguments.length === 3 ? (typeof arg2 === 'string' ? [arg2] : arg2 as string[]) : [];
	const action = arguments.length === 3 ? arg3 : arg2 as (() => void);

	// Invoke the dependent action if dependencies are all available
	const invokeDependent = function (dependent: ReadyDependent) {
		if (!dependent.action)
			return false;
		for (let d = 0; d < dependent.dependencies.length; d++) {
			const dependency = readyDependencies[dependent.dependencies[d]];
			// eslint-disable-next-line eqeqeq
			if (!(dependency == true))
				return false;
		}
		try {
			dependent.action((window as any).ExoJQuery);
			dependent.action = null;
			ready(dependent.name);
			return true;
		}
		catch (e) {
			console.error(e);

			if ((window as any).appInsights) {
				(window as any).appInsights.trackException(e, 'Cognito.ready', { readyActionName: dependent.name });
			}

			readyDependencies[dependent.name] = false;
			return false;
		}
	};

	function isDependentsArray(dependency: ReadyDependency | undefined): dependency is ReadyDependent[] {
		if (typeof dependencies === 'undefined')
			return false;
		if (typeof dependency === 'boolean')
			return false;
		if (Array.isArray(dependency))
			return true;
		return false;
	}

	// Dependency
	if (arguments.length === 1) {
		const dependencyValue = readyDependencies[name];
		readyDependencies[name] = true;
		if (isDependentsArray(dependencyValue)) {
			const dependents = dependencyValue;
			for (let d = 0; d < dependents.length; d++) {
				if (readyDependencies[dependents[d].name] !== false) {
					invokeDependent(dependents[d]);
				}
			}
		}
	}
	// Dependent
	else {
		// Create the dependent tracking object
		const dependent: ReadyDependent = { name, dependencies, action };

		// Register the dependent if it cannot be invoked
		if (!invokeDependent(dependent)) {
			for (let d = 0; d < dependent.dependencies.length; d++) {
				const dependency = readyDependencies[dependent.dependencies[d]];
				if (!dependency)
					readyDependencies[dependent.dependencies[d]] = [dependent];
				else if (dependency instanceof Array)
					dependency.push(dependent);
			}
		}
	}
}
